<template>
  <div>
    <check-base-layout
      :pagetitle="pageTitle"
      :checkInfoData="checkFrom"
    >
      <template>
        <div>
          <customer-module
            :customer-data="checkFrom.customerAccountCreditVo"
          ></customer-module>
        </div>
        <slot></slot>
      </template>
      <template v-slot:checkFooter>
        <slot name="footer">
          <check-module
            :title="`审批信息`"
          >
            <check-info-module :check-data="checkFrom.systemFlowRunAuditOrgVos" :isnot-check-result="nocheckresult"></check-info-module>
          </check-module>
        </slot>
      </template>
    </check-base-layout>
  </div>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import specialofferApi from '@/api/workbench/check'
import { deepClone } from '@/util'
export default {
  name: 'specialofferCheck',
  mixins: [poMixins],
  props: ['cellcolor'],
  created () {
    const { type, snaId } = this
    specialofferApi.specialofferCheck({
      snaId,
      type
    }).then(res => {
      this.checkFrom = deepClone(res.data.obj)
      this.$emit('update:data', deepClone(res.data.obj))
    })
  },
  data () {
    return {
      checkFrom: {},
      nocheckresult: false
    }
  },
  inject: ['pageTitle', 'type'],
  methods: {

  }
}
</script>

<style scoped lang="less">
  /deep/.el-radio{
    margin-right: 10px;
  }
  /deep/.el-radio__label{
    padding-left: 5px;
  }
</style>
